// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2ScuZ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__q8JG8"};